import HttpService from './HttpService';
import * as actionsLoadUnload from '../actions/loadUnloadAction';
import { getUrlPhysicalConfirmationApi, showMessageToastCustom, translate } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';

const httpService = new HttpService(getUrlPhysicalConfirmationApi(window));

export default class LoadUnloadService {
    static getShedsLoad(callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/mvmae/sheds`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsLoadUnload.setShedList(response.data.data));
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    if (callback) {
                        callback();
                    }
                    dispatch(endLoading());
                });
            };
        }
    }

    static getShedsConfig(callback, loading) {
        if (navigator.onLine) {
            return (dispatch) => {
                if (loading) {
                    dispatch(startLoading());
                }
                httpService.instance.get(`/api/mvmae/all-sheds-config`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsLoadUnload.setShedConfigList(response.data.data));
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    if (callback) {
                        callback();
                    }
                    if (loading) {
                        dispatch(endLoading());
                    }
                });
            };
        }
    }

    static saveShedsConfig(shedId, shedCode, movementTypeId, indConfirmCargoInAe) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());

                const dto = {
                    shedId,
                    shedCode,
                    movementTypeId,
                    indConfirmCargoInAe
                };

                httpService.instance.put(`/api/mvmae/save-shed-config`, dto, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    //Se tudo certo, atualizar a lista de sheds no reducer, pra refletir na tela:
                    if (response.status === 200) dispatch(actionsLoadUnload.updateShedConfig(dto));
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }
    static startShedLoad(putObj, callback) {
        const url = '/api/mvmae/startshedload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, putObj).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsLoadUnload.setMvm(response.data.data));
                    }
                    if (callback) {
                        callback(response.data.success);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static finishrackload(putObj, callback) {
        const url = '/api/mvmae/finishrackload';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, putObj).then((response) => {
                    if (response.status === 200 && callback) {
                        showMessageToastCustom(translate('success', 'general'), response.data.message, 3000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                        callback();
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static getMdrTypes(callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                // dispatch(startLoading());
                httpService.instance.get(`/api/mvmae/rackTypes`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {

                    if (response.status === 200 && response.data?.data) {
                        dispatch(actionsLoadUnload.setRackTypeList(response.data.data));
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    if (callback) {
                        callback();
                    }
                    // dispatch(endLoading());
                });
            };
        }
    }

    static checkRackTypeSupplier(companyId, rackTypeId, supplierId, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                dispatch(startLoading());
                httpService.instance.get(`/api/mvmae/HasRackTypeSupplierAssociation?companyId=${companyId}&rackTypeId=${rackTypeId}&supplierId=${supplierId}`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200 && response.data) {
                        callback(response.data.data);
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            };
        }
    }

    static getIsPackingFCM(rackTypeCode, supplierCode, callback) {
        if (navigator.onLine) {
            return (dispatch) => {
                // dispatch(startLoading());
                httpService.instance.get(`/api/mvmae/isPackingFCM?rackTypeCode=${rackTypeCode}&supplierCode=${supplierCode}`, { timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT, timeoutErrorMessage: translate('general.timeout') })
                    .then((response) => {
                        if (response.status === 200 && response.data && callback) {
                            callback(response.data.data);
                        }
                    }).catch((error) => {
                        showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message || error, 8000, 'mdi mdi-alert-circle-outline red-text');
                    })
            };
        }
    }

    static insertConfirmationMdrList(item, callback) {
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.post(`/api/load/item`, item).then((response) => {
                if (response.status === 200 && response.data?.data) {
                    item.id = response.data.data.id
                    item.volumeQuantity = response.data.data.volumeQuantity || item.volumeQuantity;
                    dispatch(actionsLoadUnload.insertConfirmationMdrList(item));
                }
                if (callback) {
                    callback(response.data.success);
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        };
    }

    static updateConfirmationMdrList(item, callback) {
        return (dispatch) => {
            dispatch(startLoading());
            httpService.instance.put(`/api/load/item`, item).then((response) => {
                if (response.status === 200 && response.data?.data) {

                    dispatch(actionsLoadUnload.updateConfirmationMdrList(response.data.data));
                }
                if (callback) {
                    callback(response.data.success);
                }
            }).catch((error) => {
                showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
            }).finally(() => {
                dispatch(endLoading());
            });
        };
    }

    static setMovementType(movementType, movementTypeObj) {
        return (dispatch) => { dispatch(actionsLoadUnload.setMovementType(movementType, movementTypeObj)); };
    }

    static setShed(shed, shedObj) {
        return (dispatch) => { dispatch(actionsLoadUnload.setShed(shed, shedObj)); };
    }

    static clearAll() {
        return (dispatch) => { dispatch(actionsLoadUnload.clearAll()); };
    }

    static removeConfirmationMdrList(item) {
        return (dispatch) => {
            dispatch(actionsLoadUnload.removeConfirmationMdrList(item));
        };
    }

    static clearConfirmationMdrList() {
        return (dispatch) => {
            dispatch(actionsLoadUnload.clearConfirmationMdrList());
        };
    }

    static deleteLoadItem(id, callback) {
        const url = '/api/load/' + id;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.delete(url).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data.data);
                        }
                    }
                }).catch((error) => {
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }
}

